export default __webpack_public_path__ + "static/media/File-No-1.8866df71.pdf";